import { render, staticRenderFns } from "./DialogEditNickname.vue?vue&type=template&id=1fbf67ad&scoped=true"
import script from "./DialogEditNickname.js?vue&type=script&lang=js&external"
export * from "./DialogEditNickname.js?vue&type=script&lang=js&external"
import style0 from "./DialogEditNickname.vue?vue&type=style&index=0&id=1fbf67ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fbf67ad",
  null
  
)

export default component.exports